// Overall configuration for the map
//
import bgImg from '@/assets/imgs/tilebg2.png'
// import bgImg from '@/assets/imgs/whitebg.png'
import assetDerp from '@/assets/avatars/derp.png'
import assetDerpa from '@/assets/avatars/derpa.png'

export default {
  background: bgImg,
  skins: [
    assetDerp,
    assetDerpa
  ],

  nodeSides: 6,
  nodeWiggle: 1,
  nodeDist: 1,
  nodeColor: 0x00FF00,
  nodeAlpha: 0.3,
  nodeSize: 100,
  nodeText: {
    fontFamily: 'DroidSans',
    fontSize: 30,
    fill: 0xffffff,
    stroke: 0x000000,
    strokeThickness: 3,
    dropShadow: true,
    dropShadowDistance: 0,
    dropShadowAngle: 90,
    dropShadowAlpha: 1,
    dropShadowBlur: 10
  },
  animSpeed: 600,
  clientSync: true,
  syncTimeout: 1500,

  lerpFactor: 0.07
} /**/
